import React from 'react';
import styled from 'styled-components';
import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi2';
import { useTheme, THEMES } from '../ThemeContext';
import { useT } from '../LocaleContext';
import { techColors, neonGlow } from '../styles/TechRetroEffects';

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  justify-content: center;
`;

const ToggleOption = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid ${({ active }) => (active ? techColors.borderGlow : techColors.borderMuted)};
  background: ${({ active }) => (active ? techColors.darkBgTertiary : 'transparent')};
  color: ${({ active }) => (active ? techColors.neonCyan : techColors.textSecondary)};
  ${({ active }) => active && neonGlow(techColors.neonCyan, 'subtle')}

  &:hover {
    color: ${techColors.neonCyan};
    background: ${techColors.darkBgTertiary};
  }

  svg {
    display: block;
  }
`;

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const t = useT();

  return (
    <ToggleRow role="group" aria-label={t('theme.label')}>
      <ToggleOption
        type="button"
        active={theme === THEMES.light}
        onClick={() => setTheme(THEMES.light)}
        aria-label={t('theme.light')}
        aria-pressed={theme === THEMES.light}
        title={t('theme.light')}
      >
        <HiOutlineSun />
      </ToggleOption>
      <ToggleOption
        type="button"
        active={theme === THEMES.dark}
        onClick={() => setTheme(THEMES.dark)}
        aria-label={t('theme.dark')}
        aria-pressed={theme === THEMES.dark}
        title={t('theme.dark')}
      >
        <HiOutlineMoon />
      </ToggleOption>
    </ToggleRow>
  );
};

export default ThemeToggle;
